module.exports = __webpack_public_path__ + "img/OHM_GRANDS_COMPTES.e58ed3e7.png";